
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 134961","xmlns":"http://www.w3.org/2000/svg","width":"26","height":"26","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 156004","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"data-name":"Path 156996","d":"M9.912 12.436l2 2 4.5-4.5","opacity":".4"}}),_c('path',{attrs:{"data-name":"Path 156997","d":"M5.377 11.534c0-2.135 0-3.2.415-4.017a3.812 3.812 0 011.666-1.668c.819-.415 1.883-.415 4.019-.415h3.049c2.135 0 3.2 0 4.017.415a3.811 3.811 0 011.666 1.666c.415.815.415 1.883.415 4.017v6.992a3.693 3.693 0 01-.124 1.417 1.144 1.144 0 01-1.1.623 3.692 3.692 0 01-1.279-.623h0a7.992 7.992 0 00-.81-.454 3.81 3.81 0 00-1.1-.3 7.985 7.985 0 00-.928-.028h-3.806c-2.135 0-3.2 0-4.017-.415a3.811 3.811 0 01-1.666-1.666c-.417-.819-.417-1.886-.417-4.021z"}})])])
          )
        }
      }
    